"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var formik_1 = require("formik");
var TextField_1 = __importDefault(require("../TextField"));
function AutoCompleteField(props) {
    var autoSelect = props.autoSelect, name = props.name, label = props.label, freeSolo = props.freeSolo, options = props.options, readOnly = props.readOnly, onChange = props.onChange, error = props.error, helperText = props.helperText, defaultValue = props.defaultValue, rest = __rest(props, ["autoSelect", "name", "label", "freeSolo", "options", "readOnly", "onChange", "error", "helperText", "defaultValue"]);
    var setFieldValue = (0, formik_1.useFormikContext)().setFieldValue;
    var _a = __read((0, formik_1.useField)(name), 1), field = _a[0];
    return ((0, jsx_runtime_1.jsx)(material_1.Autocomplete, __assign({ autoSelect: autoSelect, freeSolo: freeSolo, options: options, readOnly: readOnly }, rest, { onChange: function (_, value) {
            setFieldValue(name, value);
            if (onChange !== undefined) {
                onChange(value);
            }
        }, value: defaultValue || field.value, renderInput: function (params) {
            return ((0, jsx_runtime_1.jsx)(TextField_1.default, __assign({ ref: params.InputProps.ref }, params, { endAdornment: readOnly ? undefined : params.InputProps.endAdornment, readOnly: readOnly, label: label, name: name, disableFormik: true, helperText: helperText, error: error })));
        } })));
}
exports.default = AutoCompleteField;
AutoCompleteField.defaultProps = {
    readOnly: false,
    freeSolo: false,
    autoSelect: false,
    options: [],
    onChange: function () { },
    error: false,
    helperText: '',
    defaultValue: undefined,
};
//# sourceMappingURL=AutoCompleteField.js.map